import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import {
  FlyTo,
  FullScreenControl,
  MapStyle,
  Mapbox,
  NavigationControl,
} from 'components/Mapbox'

import { ReactNode, useEffect, useRef, useState } from 'react'
import { View } from 'components/Mapbox/Components/Viewport'
import { Overlay } from 'components/Mapbox/Components/Overlay'
import { Terrain } from 'components/Mapbox/Components/Terrain'
import { PerspectiveControl } from 'components/Mapbox/Components/PerspectiveControl'
import { FeatureTooltip } from 'components/Mapbox/Components/FeatureTooltip'
import { ColorKey } from './ColorKey/ColorKey'
import { StyleChange } from 'components/Mapbox/Components/StyleChange'
import MuniImport from './munidata.json'
import { FitBounds } from 'components/Mapbox/Components/FitBounds'
import MunicipalitySearch, {
  Municipality,
} from '@ta-interaktiv/react-municipality-search'
import { InteractiveToggle } from 'components/Mapbox/Components/InteractiveToggle'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { GeojsonLayer } from 'components/Mapbox/Components/GeojsonLayer'
import { SourceTable } from 'components/SourceTable'
import { useWindowSize } from 'usehooks-ts'
import { ScrollToMap } from 'components/Mapbox/Components/ScrollToMap'

var sources = require('./tamedia_hazard_sources_de.json')
var CHMask = require('./GeoData/ch-mask.geojson')
const MuniData = MuniImport as any as {
  [key: string]: {
    box: [[number, number], [number, number]]
    center: [number, number]

    id: number
    name: string
  }
}
const SwissBoundsDesktop: [[number, number], [number, number]] = [
  [5, 40],
  [11.5, 52],
]
const SwissBoundsMobile: [[number, number], [number, number]] = [
  [5.231, 44.5309],
  [11.2021, 49.0596],
]
var style = 'mapbox://styles/ta-interaktiv/clo6ukh5m00sn01qvgcyd2419/draft'
const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const [fly, setFly] = useState<
    | {
        lng: number
        lat: number
        zoom: number
      }
    | undefined
  >()
  const [zoom, setZoom] = useState<number | undefined>(6)
  const [activeMuni, setActiveMuni] = useState<Municipality | undefined>()
  const municontainer = useRef<HTMLDivElement>(null)
  const isMobile = window.innerWidth < 712
  const [frameRef, setFrameRef] = useState<HTMLDivElement | null>(null)
  return (
    <AppContainer $colorMode={colorMode}>
      <TextWidth>
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
        eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
        voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
        clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit
        amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
        nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
        sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
        rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem
        ipsum dolor sit amet.
      </TextWidth>
      <TextWidth>
        <ColorKey
          title='Lawinengefahr in der Schweiz'
          entries={[
            {
              color: '#9E272F',
              label: 'erheblich',
            },
            {
              color: '#D3343F',
              label: 'mittel',
            },
            {
              color: '#E9999F',
              label: 'gering',
            },
          ]}
        ></ColorKey>
      </TextWidth>{' '}
      <MapFrame
        returnRef={setFrameRef}
        percentOfScreenHeight={isMobile ? 75: 90}
      >
        {frameRef && (
          <Mapbox scrollTarget={frameRef}>
            <MapStyle
              colorMode={colorMode}
              lang={tenant.lang}
              lightDe={style}
              darkDe={style}
              lightFr={style}
              darkFr={style}
            />
            <NavigationControl position='top-right' />
            {/* <FullScreenControl position='top-right' /> */}
            <PerspectiveControl position='top-right' />
            <InteractiveToggle
              returnToViewAtActivation
              onDeactivate={() => setActiveMuni(undefined)}
            />
            <Terrain exaggeration={1} />
            <View
              center={{ lng: 8.3, lat: 46.7 }}
              zoom={zoom}
              minZoom={6}
              maxBounds={{
                desktop: SwissBoundsDesktop,
                mobile: SwissBoundsMobile,
              }}
            />
            {fly && <FlyTo lng={fly.lng} lat={fly.lat} zoom={fly.zoom} />}
            {/* Add CH Mask as GeoJsonLayer */}
            <GeojsonLayer
              geojson={CHMask}
              id='chmask'
              layerProperties={{
                type: 'fill',
                paint: {
                  'fill-color': colorMode === 'dark' ? '#555555' : '#E9E9E9',
                },
              }}
            />
            <GeojsonLayer
              geojson={CHMask}
              id='choutline'
              layerProperties={{
                type: 'line',
                paint: { 'line-color': '#ffffff', 'line-width': 2 },
              }}
            />
            {/* Add Tooltip */}
            <FeatureTooltip
              layer={['avalanche_heavy', 'avalanche_medium', 'avalanche_light']}
              content={(e) => {
                const uniques: any = {}
                e.forEach((f: any) => {
                  uniques[f[0]] = f
                })
                let lines = Object.values(uniques).map((f: any) => (
                  <div style={{ color: 'var(--brandblue-main)' }}>
                    {f[1].hauptprozess}ngefahr
                    <br />
                    <b>{f[1].gefahrenstufe}</b>
                  </div>
                ))
                return <ToolTip>{lines}</ToolTip>
              }}
            />
            {/* Change Cantons Label Styles on Mobile */}
            {window.innerWidth < 712 && (
              <StyleChange
                layer='canton_labels'
                properties={{
                  layout: [{ name: 'text-size', value: 12 }],
                }}
              />
            )}
            {activeMuni && activeMuni.GDENR && (
              <>
                <FitBounds
                  bounds={MuniData[activeMuni.GDENR + ''].box as any}
                  duration={1000}
                  padding={50}
                />
                <ScrollToMap />
                <StyleChange
                  layer='municipality_highlight_contour'
                  properties={{
                    layout: [],
                    paint: [
                      {
                        name: 'line-opacity',
                        value: [
                          'match',
                          ['get', 'id'],
                          [activeMuni.GDENR], //6111
                          1,
                          0,
                        ],
                      },
                    ],
                  }}
                />
              </>
            )}
            {!activeMuni && (
              <>
                <FitBounds
                  bounds={
                    [
                      [5.9559, 45.818],
                      [10.4921, 47.8084],
                    ] as any
                  }
                  duration={1000}
                  padding={50}
                />
                <StyleChange
                  layer='municipality_highlight_contour'
                  properties={{
                    layout: [],
                    paint: [
                      {
                        name: 'line-opacity',
                        value: [
                          'match',
                          ['get', 'id'],
                          [9999], //6111
                          1,
                          0,
                        ],
                      },
                    ],
                  }}
                />
              </>
            )}
            <Overlay>
              <OverlayContent>
                <MunicipalitySearch
                  locale={'de'}
                  maxResults={8}
                  municipalityData={'20230101_' + tenant.lang + '_nozip'}
                  resetOnSelect
                  selectedMunicipality={activeMuni}
                  placeholder={'Gemeinde suchen'}
                  onCloseHandler={() => {
                    setActiveMuni(undefined)
                    // setActiveBfsId(undefined)
                  }}
                  onSelectionHandler={(selectedMunicipality: Municipality) => {
                    setActiveMuni(selectedMunicipality)

                    if (municontainer.current) {
                      console.log(municontainer)
                      // municontainer.current.scrollIntoView({
                      //   behavior: 'smooth',
                      // })
                    }
                  }}
                />
              </OverlayContent>
              {/* <ColorKey
                title='Lawinengefahr in der Schweiz'
                entries={[
                  {
                    color: '#9E272F',
                    label: 'erheblich',
                  },
                  {
                    color: '#D3343F',
                    label: 'mittel',
                  },
                  {
                    color: '#E9999F',
                    label: 'gering',
                  },
                ]}
              >
                <MuniSearch>
                  <MunicipalitySearch
                    locale={'de'}
                    maxResults={8}
                    municipalityData={'20230101_' + tenant.lang + '_nozip'}
                    resetOnSelect
                    selectedMunicipality={activeMuni}
                    placeholder={'Gemeinde suchen'}
                    onCloseHandler={() => {
                      setActiveMuni(undefined)
                      // setActiveBfsId(undefined)
                    }}
                    onSelectionHandler={(
                      selectedMunicipality: Municipality
                    ) => {
                      setActiveMuni(selectedMunicipality)

                      if (municontainer.current) {
                        console.log(municontainer)
                        // municontainer.current.scrollIntoView({
                        //   behavior: 'smooth',
                        // })
                      }
                    }}
                  />
                </MuniSearch>
                <SourceTable sources={sources} />
              </ColorKey> */}
              {/* {activeMuni && <GDEDisplay>{MuniData[activeMuni].name}</GDEDisplay>} */}
            </Overlay>
          </Mapbox>
        )}
      </MapFrame>
      <TextWidth><SourceTable sources={sources} /></TextWidth>
      <TextWidth>
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
        eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
        voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
        clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit
        amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
        nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
        sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
        rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem
        ipsum dolor sit amet.
      </TextWidth>
      <TextWidth>
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
        eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
        voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
        clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit
        amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
        nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
        sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
        rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem
        ipsum dolor sit amet.
      </TextWidth>{' '}
    </AppContainer>
  )
}

const MapFrame = ({
  children,
  percentOfScreenHeight = 100,
  returnRef = () => {},
}: {
  children?: ReactNode
  percentOfScreenHeight?: number
  returnRef?: (ref: HTMLDivElement | null) => void
}) => {
  const windowSize = useWindowSize()
  const [height, setHeight] = useState<number>(0)
  const padding = windowSize.width < 712 ? 60 : 0
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setHeight(windowSize.height)
  }, [windowSize.width])

  useEffect(() => {
    returnRef(containerRef.current)
  }, [containerRef.current])

  return (
    <>
      <MapContainer
        ref={containerRef}
        style={{ paddingTop: padding + 'px', marginTop: -padding + 'px',marginBottom: padding + 'px' }}
      >
        <MapContent
          style={{ height: height * (percentOfScreenHeight / 100) + 'px' }}
        >
          {children}
        </MapContent>
      </MapContainer>

      <button
        onClick={() => {
          scrollToElement(
            containerRef.current ? containerRef.current : undefined
          )
        }}
      >
        +
      </button>
    </>
  )
}

function scrollToElement(element: HTMLElement | undefined) {
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    })
  }
}

const OverlayContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--site-background);
  padding: 8px 15px;
  @media screen and (max-width: 711px) {
    padding: 15px 15px;
  }
`

const MapContainer = styled.div`
  font-size: 12px;
  position: relative;
  padding-top: 60px;
  /* &::before {
    content: '';
    display: inline-block;
    width: 20px;
    height: 20px;
    background-color: red;
    position: absolute;
    top: -90px;
    left: 0;
  } */
`

const MapContent = styled.div`
  /* background-color: aqua; */
`

const MuniSearch = styled.div`
  background-color: aliceblue;
  color: var(--brandblue-main);
  margin-top: 15px;
  width: 100%;
  .municipality-search,
  input {
    max-width: 100%;
    width: 100%;
  }
`
const GDEDisplay = styled.div`
  top: 10px;
  left: 10px;
  /* background-color: #fff; */
  font-size: 36px;
  font-weight: 700;
`

const ToolTip = styled.div`
  color: var(--text-color);
  padding: 10px;
  text-align: center;
  b {
    margin-top: 10px;
    font-size: 18px;
  }
`
const uniqueByKey = (array: any[] = [], key: string | number = '') => {
  if (!key) {
    return array
  }

  return [
    ...new Map(array.filter(Boolean).map((item) => [item[key], item])).values(),
  ]
}

function onlyUnique(value: any, index: number, array: any[]) {
  return array.indexOf(value) === index
}

const MuniSearchContainer = styled.div`
  position: absolute;
  margin-top: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 60px;
  font-size: 18px;
  .results {
    z-index: 100;
  }
  /* .municipality-search {
    position: relative;
  }
  input {
    padding: 10px;
    font-size: 18px;
  }
  .results {
    width: 100%;
    z-index: 100;
    position: absolute;
    bottom: 0px;
    transform: translateY(100%);
    .resultHeader {
      font-size: 12px;
      display: none;
    }
    .result {
      padding-left: 10px;
      font-size: 0px;
      height: 50px;
      border-bottom: 1px solid var(--gray-6);
      background-color: var(--site-background);

      display: flex;
      align-items: center;
      b {
        font-size: 15px;
        line-height: 2em;
      }
      &:hover {
        background-color: var(--gray-6);
      }
    }
  } */
`

const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  margin-top: 60px;
  margin-bottom: 60px;
`

const Annotation = styled.div`
  background: #202346 !important;
  color: #fff;
  padding: 10px;
`
export default MainComponent
